import { isProdClient } from '@/constants'

// window.rrPartnerId = '63c12406c3020dd01ae4d19a'
// window.rrApi = {
//   addToBasket() {},
//   order() {},
//   categoryView() {},
//   view() {},
//   setCustomer() {},
//   setEmail() {},
//   recomMouseDown() {},
//   recomAddToCart() {},
// }

// window.rrApiOnReady = window.rrApiOnReady || []
// window.rrDisabledCookies = true

export const RR = {
  /**
   * Инициализирует retailRocket
   */
  // init: () => {
  //   if (isProdClient) {
  //     ;(function (d) {
  //       var ref = d.getElementsByTagName('script')[0]
  //       var apiJs,
  //         apiJsId = 'rrApi-jssdk'
  //       if (d.getElementById(apiJsId)) return
  //       apiJs = d.createElement('script')
  //       apiJs.id = apiJsId
  //       apiJs.async = true
  //       apiJs.src = '//cdn.retailrocket.ru/content/javascript/tracking.js'
  //       ref.parentNode.insertBefore(apiJs, ref)
  //     })(document)
  //   }
  // },
  /**
   * Отправляет данные о просмотре категории/группы товара
   * @param {number} categoryId - ID категории
   */
  reportCategoryView: categoryId => {
    if (isProdClient) {
      try {
        window.rrApi?.categoryView(categoryId)
      } catch (e) {}
    }
  },
  /**
   * Отправляет данные о просмотре конкретного товара
   * @param {number} productId - ID товара
   */
  reportProductView: productId => {
    if (isProdClient) {
      try {
        window.rrApi?.view(productId)
      } catch (e) {}
    }
  },
  /**
   * Отправляет данные о добавлении товара в корзину
   * @param {number} productId - ID товара
   */
  reportAddToCart: productId => {
    if (isProdClient) {
      try {
        window.rrApi?.addToBasket(productId)
      } catch (e) {}
    }
  },
  /**
   * Отправляет данные о созданном заказе
   * @param {number} orderId - ID заказа
   * @param {Array.<{id: Number, qnt: Number, price: Number}>} items - Информация о товарах
   */
  reportCreatedOrder: (orderId, items, customerInfo) => {
    if (isProdClient) {
      try {
        window.rrApi?.setCustomer(customerInfo)
        window.rrApi?.order({
          transaction: orderId,
          items,
        })
      } catch (e) {}
    }
  },
  /**
   * Отправляет базовые данные о пользователе для персонализации
   * @param {string} email - Email
   * @param {string} name - Имя
   */
  setUserInfo: (email, name) => {
    if (isProdClient) {
      window.rrApi?.setEmail(email, { name })
    }
  },
}
